import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') || '' : '';
}
/**
 * Envia um formulário "de verdade" (navegação completa do navegador).
 * Usado para rotas antigas que redirecionam para telas em Blade, como o
 * construtor, e para envios com arquivo.
 */
export function submitNativeForm(action, data, method = 'post') {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = action;
    form.style.display = 'none';
    const hasFile = Object.values(data).some((v) => v instanceof File);
    if (hasFile)
        form.enctype = 'multipart/form-data';
    const append = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    };
    append('_token', csrfToken());
    if (method !== 'post')
        append('_method', method.toUpperCase());
    Object.entries(data).forEach(([name, value]) => {
        if (value === null || value === undefined)
            return;
        if (value instanceof File) {
            const input = document.createElement('input');
            input.type = 'file';
            input.name = name;
            const transfer = new DataTransfer();
            transfer.items.add(value);
            input.files = transfer.files;
            form.appendChild(input);
            return;
        }
        append(name, typeof value === 'boolean' ? (value ? '1' : '0') : String(value));
    });
    document.body.appendChild(form);
    form.submit();
}
export function stripHtml(html) {
    // Separa os parágrafos antes de juntar o texto, para o endereço não colar na frase seguinte.
    // DOMParser não executa scripts nem carrega recursos (img onerror etc.).
    const text = new DOMParser().parseFromString(html.replace(/<\/p>/gi, '</p> '), 'text/html').body.textContent || '';
    return text
        .replace(/\|\s*https?:\/\/\S+/, '')
        .replace(/\s+/g, ' ')
        .trim();
}
export function slugify(value) {
    return value
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 60);
}
const loadedScripts = {};
/**
 * Carrega um script externo uma única vez (Stripe, Pagar.me, CKEditor, amCharts...),
 * com as mesmas URLs usadas nas telas antigas.
 */
export function loadScript(src) {
    if (!loadedScripts[src]) {
        loadedScripts[src] = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => {
                delete loadedScripts[src];
                reject(new Error(`Falha ao carregar ${src}`));
            };
            document.head.appendChild(script);
        });
    }
    return loadedScripts[src];
}
/** Carrega um CSS externo uma única vez. */
export function loadStyle(href) {
    if (document.querySelector(`link[data-src="${href}"]`))
        return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.src = href;
    document.head.appendChild(link);
}
/** Formata valores em reais. */
export function money(value, currency = 'BRL') {
    const n = typeof value === 'string' ? parseFloat(value) : value || 0;
    return n.toLocaleString(currency === 'BRL' ? 'pt-BR' : 'en-US', { style: 'currency', currency });
}
